/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Addons_Confirm_Downgrade_Desc_ChangeInputs */



/**
* | output |
* | --- |
* | "Your storage will change to {label} on {date}. You keep your current storage until then." |
*
* @param {Sub_Addons_Confirm_Downgrade_Desc_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_downgrade_desc_change = /** @type {((inputs: Sub_Addons_Confirm_Downgrade_Desc_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Downgrade_Desc_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Speicher wird am ${i?.date} auf ${i?.label} geändert. Sie behalten Ihren aktuellen Speicher bis dahin.`)
	return /** @type {LocalizedString} */ (`Your storage will change to ${i?.label} on ${i?.date}. You keep your current storage until then.`)
});